import { useMemo, useState } from 'react';

import { fn, int, length, required } from 'js/utils/Validation/validationRules';

export const useValidationConfig = () => {
    const t = (key) => `playtech.mobile.system.verifycardpin.error.pin.${key}`;
    const [errorPin, setErrorPin] = useState({ error: false, value: '' });

    const validationConfig = useMemo(() => ({
        pin: [
            required({ error: t('required') }),
            length({
                min: 4,
                max: 6,
                error: t('length')
            }),
            int({ error: t('integer') }),
            fn({
                fn(value) {
                    if (errorPin.error && errorPin.value === value) {
                        return [t('pinnotmatch')];
                    }
                }
            })
        ]
    }), [errorPin]);

    return { validationConfig, setErrorPin };
};
